/**
 * Create OrderMethods context for custom hook
 */

import { createContext } from 'react'

const OrderMethodsContext = createContext({
  fetchOrderMethods: () => {},
  fetchOrderMethodsAll: () => {},
  orderMethodsReady: false,
  orderMethods: [],
})

export default OrderMethodsContext
